/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The IIdentity model module.
 * @module model/IIdentity
 * @version V1
 */
class IIdentity {
    /**
     * Constructs a new <code>IIdentity</code>.
     * @alias module:model/IIdentity
     */
    constructor() { 
        
        IIdentity.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>IIdentity</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/IIdentity} obj Optional instance to populate.
     * @return {module:model/IIdentity} The populated <code>IIdentity</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new IIdentity();

            if (data.hasOwnProperty('authenticationType')) {
                obj['authenticationType'] = ApiClient.convertToType(data['authenticationType'], 'String');
            }
            if (data.hasOwnProperty('isAuthenticated')) {
                obj['isAuthenticated'] = ApiClient.convertToType(data['isAuthenticated'], 'Boolean');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>IIdentity</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>IIdentity</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['authenticationType'] && !(typeof data['authenticationType'] === 'string' || data['authenticationType'] instanceof String)) {
            throw new Error("Expected the field `authenticationType` to be a primitive type in the JSON string but got " + data['authenticationType']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }

        return true;
    }


}



/**
 * @member {String} authenticationType
 */
IIdentity.prototype['authenticationType'] = undefined;

/**
 * @member {Boolean} isAuthenticated
 */
IIdentity.prototype['isAuthenticated'] = undefined;

/**
 * @member {String} name
 */
IIdentity.prototype['name'] = undefined;






export default IIdentity;

